export default __webpack_public_path__ + "static/media/HomeWhite.32b29cff.svg";